import React, { useEffect, useState } from 'react';

const TextareaRenderer = ({ field, value, onChange, error, readOnly }) => {
  const fieldId = field.field_id || field.name;
  const isOptionalNotesField = !field.required && /justification|notes?/i.test(field.label || '');
  const [expanded, setExpanded] = useState(Boolean(value));

  useEffect(() => {
    if (value) setExpanded(true);
  }, [value]);

  if (isOptionalNotesField && !expanded) {
    return (
      <div className="mb-2">
        <button
          type="button"
          onClick={() => setExpanded(true)}
          className="flex w-full items-center justify-between rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-left text-sm font-medium text-gray-700 hover:bg-gray-100"
          aria-expanded="false"
        >
          <span>{field.label}</span>
          <span aria-hidden="true">+</span>
        </button>
      </div>
    );
  }

  return (
    <div className="mb-2">
      <div className="mb-1 flex items-center justify-between">
        <label htmlFor={fieldId} className="block text-sm font-medium text-gray-700">
          {field.label}
          {field.required && <span className="text-red-500 ml-1">*</span>}
        </label>
        {isOptionalNotesField && (
          <button
            type="button"
            onClick={() => setExpanded(false)}
            className="text-xs font-medium text-gray-500 hover:text-gray-700"
            aria-expanded="true"
          >
            Collapse
          </button>
        )}
      </div>
      {field.help_text && (
        <p className="text-xs text-gray-500 mb-1">{field.help_text}</p>
      )}
      <textarea
        id={fieldId}
        data-testid={`field-${fieldId}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={field.placeholder}
        disabled={readOnly}
        rows={field.rows || 3}
        aria-label={field.aria_label || undefined}
        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          error ? 'border-red-500' : 'border-gray-300'
        } ${readOnly ? 'bg-gray-100' : ''}`}
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
};

export default TextareaRenderer;
